import { graphql } from "@opensea/graphql"

export const AccountSwitcherAccountItemsFragment = graphql(`
  fragment AccountSwitcherAccountItems on Profile {
    username
    displayName
    address
    imageUrl
    portfolioSummary {
      estimatedTokenValue {
        usd
      }
    }
  }
`)
